module.exports = __webpack_public_path__ + "static/media/6.eb358529.png";